import { EVENT_NAMES } from 'constants/event';

export const viewPage = (url: string): void => {
  window.dataLayer?.push({
    event: EVENT_NAMES.pageLoad,
    page_type: url,
    digital_product: '',
    env: window.location.hostname,
  });
};
